export enum MonthsEnum {
  FIRST = 'MONTH_FIRST',
  SECOND = 'MONTH_SECOND',
  THIRD = 'MONTH_THIRD',
  FOURTH = 'MONTH_FOURTH',
  FIFTH = 'MONTH_FIFTH',
  SIXTH = 'MONTH_SIXTH',
  SEVENTH = 'MONTH_SEVENTH',
  EIGHTH = 'MONTH_EIGHTH',
  NINETH = 'MONTH_NINETH',
  TENTH = 'MONTH_TENTH',
  ELEVENTH = 'MONTH_ELEVENTH',
  TWELFTH = 'MONTH_TWELFTH'
}
